import type { MenuItem } from '@/consts/navigation';

export const APPROVALS_ROUTE = '/pms/approvals';

export const hasRoute = (items: MenuItem[], route: string): boolean =>
  items.some((item) => item.to === route || (item.children !== undefined && hasRoute(item.children, route)));
